import styled from "styled-components";
import { getTheme } from "Theme.js";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const theme = getTheme();

export { default as ProfileButton } from "./ProfileButton.js";
export { default as StandardTable } from "./StandardTable.js";
export { default as PermissionDenied } from "./PermissionDenied.js";
export { default as Confirm } from "./Confirm.js";
export { default as DatePicker } from "./datepicker.js";
export { default as Time } from "./TimeModal.jsx";
export { default as Adjustment } from "./Adjustment.js";
export { default as NavigationBar } from "./NavigationBar.js";
export { default as SearchBar } from "./SearchBar";
export { default as FolderContainer } from "./FolderContainer";
export { default as SelectorSearch } from "./SelectorSearch";
export { default as Selector } from "./Selector";
export { default as Button } from "./Button.tsx";
export { default as Table } from "./table/index.jsx";
export { default as InfiniteTable } from "./InfiniteTable";
export { default as ToggleButton } from "./ToggleButton";
export { default as ToggleSwitch } from "./ToggleSwitch";
export { default as Input } from "./Input.jsx";
export { default as Modal } from "./Modal";
export { default as AccountingFolderContainer } from "./AccountingFolderContainer";

export const Row = styled.div`
  display: flex;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 4px 0px;
`;

export const FormHeader = styled.div`
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  padding: 4px;
  margin-bottom: 5px;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 5px;
`;

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid ${theme.INPUT_BORDER};
  height: 250px;
  gap: 2px;
  overflow-y: auto;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${theme.INPUT_BACKGROUND};
  color: ${theme.INPUT_TEXT};
  border-radius: 4px;
  padding: 4px;
  border: 2px solid ${theme.INPUT_BACKGROUND};
  font-weight: 600;
  gap: 5px;
  ${(props) =>
    props.onClick &&
    `cursor: pointer; 
  :hover {
    border: 2px solid ${theme.MAIN_COLOR};
  }
  `}
`;

export const CurvedHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
  color: white;
  padding: 8px;
  border-bottom: 2px solid ${theme.BLACK};
  background: ${theme.MAIN_COLOR};
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  min-height: 40px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
`;

export const Error = styled.h3`
  color: ${theme.NEGATIVE};
  margin: 0;
`;
export const EditButton = styled.button`
  display: flex;
  border: none;
  background: none;
  color: ${theme.BUTTON_COLOR};
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-left: auto;
`;

export const BackButton = styled(Button)`
  width: 150px;
  background: ${theme.BUTTON_COLOR_GREY};
`;

export const SectionTitle = styled.h2``;

export const FilterBar = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 5px;
  gap: 20px;
  flex-wrap: wrap;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 55px;
  right: 0;
  width: 60vw;
  justify-content: right;
  align-items: center;
`;

export const ButtonHeaderWrapper = styled.div`
  margin-left: auto;
  right: 10px;
  position: absolute;
  display: flex;
  gap: 8px;
  top: 70px;
  align-items: center;
  @media (max-width: 1100px) {
    top: 48px;
  }
`;

export const FloatingBackButton = styled.button`
  position: fixed;
  top: 20px;
  left: 20px;
  background-color: ${theme.MAIN_COLOR};
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
`;

export const PageBackground = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #e3f2fd 0%, #f5faff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoBannerImage = styled.img`
  min-width: 100px;
  max-width: 600px;
  margin-top: 20px;
`;

export const Clickable = styled.div`
  cursor: pointer;
  font-size: 16px;
  :hover {
    background: ${theme.SECONDARY_COLOR};
    border-radius: 100px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 4px;
  background: ${theme.MAIN_COLOR};
  margin: 8px 0px;
`;

export const IconButton = styled(FontAwesomeIcon)`
  cursor: pointer;
  font-size: 26px;
  color: ${theme.TEXT};
  margin: auto 6px;
`;

export const TextButton = styled.div`
  cursor: pointer;
  font-size: 16px;
  color: ${theme.BUTTON_COLOR};
  display: inline-block;
  padding-left: 4px;
`;
